export default function Dates({invoiceNumber, invoiceDate, dueDate}) {
    return (
        <>

            <article className="mt-2 mb-2 flex items-end justify-end">
                <ul>
                    <li className="p-1 bg-gray-100">
                        <span className="font-bold">Début validité:</span> {invoiceDate}
                    </li>
                    <li className="p-1 ">
                        <span className="font-bold">Fin de validité:</span> {dueDate}
                    </li>
                </ul>
            </article>

        </>
    )
}
